/* src/app/order/components/additional-questions-details/transfer-additional-questions-details/transfer-additional-questions-details.style.scss */
.additional-questions-card nb-card-body .card-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}
.additional-questions-card nb-card-body #card-header {
  font-size: 22px;
  font-weight: bold;
  color: #007d40;
  margin: 0;
  flex: 1;
  overflow-wrap: break-word;
}
.additional-questions-card nb-card-body #card-header.collapsed {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.additional-questions-card nb-card-body .toggle-details-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}
.additional-questions-card nb-card-body .toggle-details-section nb-icon {
  position: relative;
  top: 2px;
}
.additional-questions-card nb-card-body #additional-questions-details #header {
  color: #007d40;
}
.additional-questions-card nb-card-body #header {
  margin-bottom: 15px;
  margin-top: 30px;
}
.client-property-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-bottom: 0;
  display: inline;
}
.client-property-label span {
  vertical-align: middle !important;
}
.client-property {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #585858;
  margin-bottom: 20px !important;
}
.with-padding-bottom {
  padding-bottom: 20px;
}
.placeholder {
  font-family: Arial, sans-serif;
  color: #8C8C8C;
  font-size: 15px;
}
.change-button {
  margin-top: 20px;
  float: right;
}
.change-button.collapsed {
  display: none;
}
.radio-row.form-row {
  flex-wrap: nowrap;
  flex-direction: column;
}
.radio-row.form-row .radio-with-question {
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
}
.radio-row.form-row .radio-column {
  min-width: 80px;
}
@media screen and (max-width: 767px) {
  .radio-row.form-row .radio-with-question {
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 767px) {
  .radio-row.form-row {
    flex-direction: column-reverse;
  }
}
/*# sourceMappingURL=transfer-additional-questions-details.style.css.map */
